import * as React from 'react';

function SvgProgressFirstInstalmentPayment(props) {
  return (
    <svg viewBox="0 0 23 19" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20 6.84a6.948 6.948 0 00-1.429-.425V5.74H1.43v7.833c0 .394.32.714.714.714h8.226c.07.494.191.972.358 1.428H1.43c-.79 0-1.429-.64-1.429-1.429V1.43A1.427 1.427 0 011.429 0H18.57C19.361 0 20 .64 20 1.429v5.41zM1.429 4.286V2.143c0-.395.32-.714.714-.714h15.714c.395 0 .714.32.714.714v2.143H1.43zm7.142 7.857v-1.429a.714.714 0 00-1.428 0v1.43a.714.714 0 001.428 0zm-2.857 0a.714.714 0 01-1.428 0v-1.429a.714.714 0 011.428 0v1.43zm11.572-4.572a5.714 5.714 0 110 11.429 5.714 5.714 0 010-11.429zm0 9.998a4.284 4.284 0 100-8.568 4.284 4.284 0 000 8.568zM19.2 12.55a.65.65 0 110 1.3h-2a.65.65 0 01-.65-.65v-2a.65.65 0 111.3 0v1.35h1.35z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgProgressFirstInstalmentPayment;
